import { useCallback, useEffect, useState } from 'react'
import { IApiState } from 'types/baseTypes'

export const useFetch = <T>(fn: () => Promise<T>, deps = []) => {
  const [result, setResult] = useState<IApiState<T>>({
    loading: true
  })

  const doFetch = useCallback(async () => {
    if (!fn) return
    setResult((prev) => ({
      ...prev,
      error: null,
      loading: true
    }))

    try {
      const response = await fn()
      setResult({
        data: response,
        loading: false
      })
    } catch (error) {
      setResult((prev) => ({
        ...prev,
        error,
        loading: false
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fn])

  useEffect(() => {
    doFetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  return { ...result, refetch: doFetch } as IApiState<T>
}
